import { httpClient } from '@/lib/api';

import type { AuthUser, LoginPayload, LoginResponse } from '../types';

/** Authentification dédiée aux comptes consultants, distincte des utilisateurs internes. */
export const authApi = {
  /** `POST /consultant-auth/login` — dépose le cookie de refresh et renvoie le token d'accès. */
  login: (payload: LoginPayload): Promise<LoginResponse> =>
    httpClient.post<LoginResponse>('/consultant-auth/login', payload, { skipAuth: true }),

  /**
   * `POST /consultant-auth/refresh` — échange le cookie de refresh contre un
   * nouveau token d'accès.
   *
   * ⚠️ À n'appeler que par `refreshSession()` (`../session-refresh.ts`), qui
   * porte le verrou à un seul appel en vol. L'appeler directement rouvre la
   * course qui fait révoquer toutes les sessions du compte.
   */
  refresh: (): Promise<LoginResponse> =>
    httpClient.post<LoginResponse>('/consultant-auth/refresh', undefined, { skipAuth: true }),

  /** `POST /consultant-auth/logout` — révoque le refresh token et efface le cookie. */
  logout: (): Promise<void> => httpClient.post<void>('/consultant-auth/logout'),

  /** `GET /consultant-auth/me` — profil de l'utilisateur connecté. */
  me: (): Promise<AuthUser> => httpClient.get<AuthUser>('/consultant-auth/me'),
  forgotPassword: (email: string): Promise<{ message: string }> =>
    httpClient.post('/consultant-auth/forgot-password', { email }, { skipAuth: true }),
  resetPassword: (token: string, password: string): Promise<{ message: string }> =>
    httpClient.post('/consultant-auth/reset-password', { token, password }, { skipAuth: true }),
};
